import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Message, Modal } from '@arco-design/web-react';
import { IconBug } from '@arco-design/web-react/icon';
import { apiClient } from '@/services/apiClient';
import { API_ENDPOINTS } from '@/config/apiEndpoints';

const FormItem = Form.Item;

const ReportProblemButton = ({ stepLabel, previewMode = false, asButton = false }) => {
  const { t } = useTranslation('onboarding');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => {
    form.resetFields();
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const handleSubmit = async () => {
    const values = await form.validate();
    const message = (values.message || '').trim();
    if (!message) {
      Message.warning(t('reportProblem.messages.describeFirst'));
      return;
    }

    setLoading(true);
    try {
      if (previewMode) {
        Message.success(t('reportProblem.messages.success'));
        setVisible(false);
        return;
      }
      await apiClient.post(API_ENDPOINTS.ONBOARDING_REPORT_ISSUE, {}, {
        message,
        step: stepLabel,
        page: window.location.pathname
      });
      Message.success(t('reportProblem.messages.success'));
      setVisible(false);
    } catch (error) {
      console.error('Error reportando problema:', error);
      Message.error(t('reportProblem.messages.error'));
    } finally {
      setLoading(false);
    }
  };

  const trigger = asButton ? (
    <Button
      size="large"
      status="danger"
      type="outline"
      icon={<IconBug />}
      onClick={handleOpen}
    >
      {t('reportProblem.title')}
    </Button>
  ) : (
    <Button
      type="text"
      icon={<IconBug />}
      onClick={handleOpen}
      style={{ padding: 0 }}
    >
      {t('reportProblem.title')}
    </Button>
  );

  return (
    <>
      {trigger}

      <Modal
        title={t('reportProblem.title')}
        visible={visible}
        onOk={handleSubmit}
        onCancel={handleClose}
        confirmLoading={loading}
        okText={t('reportProblem.submit')}
        cancelText={t('reportProblem.cancel')}
      >
        <Form form={form} layout="vertical">
          <FormItem
            label={t('reportProblem.label')}
            field="message"
            rules={[{ required: true, message: t('reportProblem.validation.required') }]}
          >
            <Input.TextArea
              rows={4}
              maxLength={2000}
              showWordLimit
              placeholder={t('reportProblem.placeholder')}
            />
          </FormItem>
        </Form>
      </Modal>
    </>
  );
};

export default ReportProblemButton;
